import { SUPPORTED_LOCALES, I18N_FALLBACK_LOCALE, type SupportedLocale } from '@withjoy/locale';

/**
 * The source/fallback locale ('en-US'), re-exported from the org-wide
 * registry so joy-web manages no locale values locally. Replaces the old
 * LANGUAGES named-key map — ENGLISH_BASE was its only consumed key.
 */
export { I18N_FALLBACK_LOCALE };

/**
 * joy-web's supported locales = the org-wide canonical registry from
 * `@withjoy/locale`, verbatim. Per the i18n registry contract, no repo
 * narrows or widens this set locally — equal locale support flows through
 * every part of the system (FE UI → BE services). When the registry grows,
 * bumping `@withjoy/locale` widens this set and the auto-translate bot
 * backfills the bundles; the verify-translations deploy gate holds prod
 * until the backfill lands.
 */
export const SUPPORTED_LANGUAGE_CODES: SupportedLocale[] = [...SUPPORTED_LOCALES];

/**
 * Cookie persisting a guest's language pick from the guest-site selector
 * (PRNT-4574). Path-scoped to /<eventHandle> so choices are per event. Admin
 * routes live UNDER the handle (/<eventHandle>/edit/…), so RFC 6265
 * path-matching sends the cookie there too — admin surfaces therefore ignore
 * it explicitly (PRNT-4910): the server strips it before language detection
 * (stripGuestLanguageCookieOnAdmin) and the client language chain skips it
 * (useGuestSelectedLanguageGeoLocale). Read server-side by the i18next
 * LanguageDetector (see getInitOptions) so guest-site SSR first paint matches.
 */
export const GUEST_LANGUAGE_COOKIE_NAME = 'joyGuestLanguage';

/**
 * Base language part of the source language (`'en'`). Helpful for comparisons
 * against a region-stripped language code (e.g. `locale.language.split('-')[0]`)
 * where you want to ask "is this the source-language family?" without caring
 * about the region tag.
 */
export const DEFAULT_LANGUAGE_BASE = I18N_FALLBACK_LOCALE.split('-')[0];
